import request from "@/utils/request";

// 获取文章列表
export function getPageList(data) {
  return request({
    url: `/content-meta/front/${data.contentTypeCode}/pagelist?page=${data.page}&size=${data.size}`,
    method: "post",
    data,
  });
}
// 资质用户列表
export function getKeyPageList(data) {
  return request({
    url: `/chzz-user/pagelist?page=${data.page}&size=${data.size}`,
    method: "post",
    data,
  });
}
// 获取服务指南列表

export function getServiceList(data) {
  console.log("data", data);
  return request({
    url: `/content-meta/front/${data.contentTypeCode}/pagelist?page=${data.page}&size=${data.size}`,
    method: "post",
    data,
  });
}

// 常见问题获取

export function getCommonQuestion(data) {
  return request({
    url: `/problem/pagelist?page=${data.page}&size=${data.size}`,
    method: "post",
    data,
  });
}
export default {
  getPageList,
  getKeyPageList,
  getServiceList,
  getCommonQuestion,
};
